import { useEffect, useState } from "react";
import PointsBadgesSection from "../../components/points/PointsBadgesSection";
import PointsHeader from "../../components/points/PointsHeader";
import PointsLeaderboardSection from "../../components/points/PointsLeaderboardSection";
import PointsLogsSection from "../../components/points/PointsLogsSection";
import PointsMissionsSection from "../../components/points/PointsMissionsSection";
import PointsRewardsSection from "../../components/points/PointsRewardsSection";
import { configurations } from "../../configurations";
import { URLdecode } from "../../utils/url";
import { useLocation } from "react-router-dom";

function PointsPage() {
  const location = useLocation();
  const params = URLdecode();
  const [tab, setTab] = useState(
    params?.tab || configurations.milesPoints.tabs.mission.code
  );

  useEffect(() => {
    if (params?.tab) {
      setTab(params.tab);
    }
  }, [location.search]);

  return (
    <div className="w-full flex flex-col bg-[#F3F5F9] min-h-screen px-2 py-6 items-center">
      <div className="w-full max-w-7xl flex flex-col">
        <PointsHeader />
        <div className="flex flex-col w-full mt-4">
          {(() => {
            const tabs = configurations.milesPoints.tabs;
            switch (tab) {
              case tabs.badge.code:
                return <PointsBadgesSection />;
              case tabs.reward.code:
                return <PointsRewardsSection />;
              case tabs.leaderboard.code:
                return <PointsLeaderboardSection />;
              case tabs.log.code:
                return <PointsLogsSection />;
              default:
                return <PointsMissionsSection />;
            }
          })()}
        </div>
      </div>
    </div>
  );
}

export default PointsPage;
